export const  ICON_MAP: { [key: string]: string } = {
    info: 'info_outline',
    error: 'error',
    warning: 'warning',
    success: 'check_circle',
  };


export const COMMON_CONST ={
  wholesale: 'Wholesale Order',
  prescription: 'Prescription Order'
}  